var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.509 6.658 7.667 9.99l3.158-3.333"
})));
export { SvgIcChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNC41MDg3OSA2LjY1Nzg0TDcuNjY2NjggOS45OTExN0wxMC44MjQ2IDYuNjU3ODQiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";